import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SignoGerenciadora } from '../gerencias-interface/gerencias-interface';
import { SignoGerenciasService } from '../gerencias-service/gerencias.service';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';

@Component({
  selector: 'app-gerencias-modificacion',
  templateUrl: './gerencias-modificacion.component.html',
  styleUrls: ['./gerencias-modificacion.component.scss']
})
export class GerenciasModificacionComponent implements OnInit {
  form: FormGroup;
  signoGerencia: SignoGerenciadora;
  flagLoaded: boolean = false;

  constructor(
    private signoGerenciasService: SignoGerenciasService,
    private router: Router,
    private guiMsjService: GuiMsjService,
  ) {}

  ngOnInit(): void {
    this.getEstadoGerencia();
    this.createForm();
  }

  get gerenciaNoValido() {
    return this.form.get('nombre').invalid && this.form.get('nombre').touched;
  }

  async getGerencia() {
    return (this.signoGerencia = this.signoGerenciasService.getGerenciaSeleccionada());
  }

  async getEstadoGerencia() {
    if (this.getGerencia() === undefined) {
      await this.router.navigateByUrl('/gerenciadoras-listado');
    } else {
      await this.getGerencia();
      this.flagLoaded = true;
    }
  }

  createForm() {
    this.form = new FormGroup({
      nombre: new FormControl(this.signoGerencia?.nombre, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(50),
      ]),
      activa: new FormControl(this.signoGerencia?.activa),
    });
  }

  async updateGerencia() {
    await this.guiMsjService.msjFormSubmit('Guardando');
    this.signoGerenciasService.updateGerencia(this.signoGerencia._id, await this.setDataForma());
    await this.guiMsjService.msjFormSubmit('DatosGuardados');
    this.router.navigateByUrl('/gerenciadoras-listado');
  }

  async setDataForma(): Promise<SignoGerenciadora> {
    const gerencia: SignoGerenciadora = {
      nombre: this.form.value.nombre || '',
      activa: this.form.value.activa || false,
    };
    return gerencia;
  }
}